import React, { useState } from "react";
import PropTypes from "prop-types";
import { httpClient, useErrorNavigator } from "@sia/style-guide";

const defaultValue = {
  error: null,
  status: null,
  statusText: null,
  setError: () => null,
};
export const HttpErrorContext = React.createContext(defaultValue);

const HttpErrorContextProvider = (props) => {
  const [error, setError] = useState(defaultValue);
  httpClient.setErrorCallBack(setError);

  const navigate = useErrorNavigator();
  httpClient.setNavigationCallBack(navigate);

  if (error.error) {
    console.error("HttpErrorContext", error);
  }

  // @ts-ignore
  return <HttpErrorContext.Provider value={{ ...error, setError }}>{props.children}</HttpErrorContext.Provider>;
};

HttpErrorContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default HttpErrorContextProvider;
